










import { Component, Mixins } from "vue-property-decorator";
import { default as TexturePattern } from "./TexturePattern.vue";
import { ShapeDrawableMixin } from "./mixins";

@Component({
  components: {
    TexturePattern,
  },
})
export default class BoxLineDrawer extends Mixins(ShapeDrawableMixin) {
}
